import React, { useCallback } from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { Close, ListFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { IconButton, Input, Stack } from '@lyearn/ui';
import ReactionSelector from '@/modules/corporate/modules/community/views/CommunityEditor/components/CommunityEditorSidebar/components/CommunityChannelEditor/components/ReactionSelector';

export const inputStyles = css`
  padding-inline-start: 0;
  padding-inline-end: 3.2rem;
  &:hover {
    border-color: var(--interactive-border);
  }
`;

interface NameAndEmojiInputProps {
  name: string;
  icon: string;
  onChangeName: (value: string) => void;
  onChangeIcon: (reaction: string) => void;
  error: string;
  placeholder: string;
}

const CHARACTER_LIMIT = 50;

function NameAndEmojiInput(props: NameAndEmojiInputProps) {
  const { t } = useTranslation();
  const { name, icon, onChangeName, onChangeIcon, error, placeholder } = props;

  const _onChangeName = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      onChangeName(event.currentTarget.value);
    },
    [onChangeName],
  );

  const _onChangeIcon = useCallback(
    (emoji: any) => {
      emoji && onChangeIcon(emoji);
    },
    [onChangeIcon],
  );

  const onClear = useCallback(() => {
    onChangeName('');
    onChangeIcon('');
  }, [onChangeName, onChangeIcon]);

  return (
    <Stack alignItems="center" className="w-full">
      <Input
        characterLimit={CHARACTER_LIMIT}
        className={cn('w-full', inputStyles)}
        error={!!error}
        inputProps={{
          className: 'ms-12',
        }}
        placeholder={placeholder}
        size="large"
        startAdornment={
          <ReactionSelector
            EmojiDefaultIcon={ListFill}
            className={{ button: 'px-12' }}
            icon={icon}
            onSelect={_onChangeIcon}
          />
        }
        value={name}
        onChange={_onChangeName}
      />
      <IconButton
        Icon={Close}
        appearance="secondary"
        className={cn('hover:bg-transparent -ms-32', name || icon ? '' : 'hidden')}
        color="secondary"
        shape="square"
        variant="ghost"
        onClick={onClear}
      />
    </Stack>
  );
}

export default NameAndEmojiInput;
